// Pure reveal-gate state machine for the hair splat.
//
// The splat stays HIDDEN until its first valid color shade is applied to the
// packed array — so Spark never renders the raw, unshaded PLY colors (the
// gray-flash at load: the mesh was made visible in _init before mat_mod →
// NeuralBSDF → shade had run, and on the GPU-shade path before the first async
// readback had even landed). Once the first shade lands, visibility follows the
// caller's enabled intent (`wantVisible`).
//
// Split out of HairRenderer so the transitions are unit-testable; HairRenderer
// owns the THREE/GPU side-effects (setting splatMesh.visible, kicking a shade).

export function createRevealGate(wantVisible = false) {
  return { revealed: false, wantVisible: !!wantVisible };
}

// First valid shade landed in the packed array. Returns the splat visibility to
// apply. Idempotent — later shades just re-affirm `wantVisible`.
export function onShadeApplied(gate) {
  gate.revealed = true;
  return gate.wantVisible;
}

// Enabled flag toggled. Returns { visible, needsShade }:
//   - disabling always hides;
//   - enabling after reveal shows immediately (colors are already packed);
//   - enabling before the first shade must NOT show gray → stay hidden and
//     request a shade (whose apply then reveals via onShadeApplied).
export function onSetEnabled(gate, value) {
  gate.wantVisible = !!value;
  if (!value) return { visible: false, needsShade: false };
  if (gate.revealed) return { visible: true, needsShade: false };
  return { visible: false, needsShade: true };
}
